<ng-container *ishHasNotRole="['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER']">
  <div class="footer">
    <div class="container-fluid">
      <ish-lazy-content-include includeId="include.footer.content.pagelet2-Include"></ish-lazy-content-include>
    </div>
  </div>
</ng-container>
